<div class="capture">
  <form class="form"  [formGroup]="formRegistry">
    <div class="location">
      <app-address-registry
        #locacao 
        [formAddress]="formRegistry"
        [typeModal]="2" [router]="'registro'"
        [cepValue]="'123212312'"
        (sendFormRequest)="getFormLocation($event)"
      ></app-address-registry>         
    </div>
    <div class="um" #tipo>
      <app-capture-unit-product></app-capture-unit-product>
    </div>
    <div class="tres" #venda>
      <app-sale-and-rent [forms]="formSaleRent"></app-sale-and-rent>
    </div>
    <div class="quatro" #tipo>
      <app-more-information></app-more-information>
    </div>
    <div class="dois" #unidade>
      <app-proprietary (sendValue)="sendValue($event)"></app-proprietary>
    </div>
    <div class="btn-actions">
      <lib-button-tertiary (click)="routerBack()">Cancelar</lib-button-tertiary>
      <lib-button-primary (click)="sendFormRegistry()">Salvar</lib-button-primary>
    </div>
  </form>
</div>